import { useForm } from 'react-hook-form';
import './clients.css';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';

function FormClient({closeModal, currentClient}) {

  const[paymentMethodArr, setPaymentMethodArr] = useState([]);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isValid },
  } = useForm({mode: 'onChange'});

  const paymentConditionValue = watch("paymentConditions");
  const paymentMethodValue = watch("paymentMethod");

  useEffect(() => {
    if(currentClient) {
      setValue('number_client', currentClient.number_client);
      setValue('name', currentClient.name);
      setValue('rfc', currentClient.rfc);
      setValue('phone', currentClient.phone);
      setValue('street', currentClient.street);
      setValue('postalCode', currentClient.zip_code);
      setValue('city', currentClient.city);
      setValue('state', currentClient.state);
      setValue('municipality', currentClient.municipality);
      setValue('cologne', currentClient.colony);
      setValue('countryText', currentClient.country);
      setValue('email', currentClient.mail);
      setValue('oracleClient', currentClient.payment_account);
      setValue('paymentConditions', currentClient.payment_condition);
      setValue('customerPrefix', currentClient.prefix);
    }
  }, [])

  useEffect(() => {
    if(currentClient) {
      if(paymentMethodArr.length !== 0) {
        setValue('paymentMethod', currentClient.payment_method);
      }
    }
  }, [paymentMethodArr])

  useEffect(() => {
    let arrPayment
    if(!paymentConditionValue && paymentConditionValue === "") {
      setValue('paymentMethod', "")
    }
    if(paymentConditionValue === "1" && paymentMethodValue === "4" ) {
      setValue('paymentMethod', "")
    }

    if(paymentConditionValue === "1") {
      arrPayment = [
        {id: 1, text: "Efectivo"},
        {id: 2, text: "Cheque"},
        {id: 3, text: "Transferencia"}
      ];
    } else if(paymentConditionValue === "2" || paymentConditionValue === "3") {
      arrPayment = [
        {id: 1, text: "Efectivo"},
        {id: 2, text: "Cheque"},
        {id: 3, text: "Transferencia"},
        {id: 4, text: "otro"}
      ];
    } else {
      arrPayment = [];
    }
    setPaymentMethodArr(arrPayment);
  }, [paymentConditionValue])

  const handleClientSubmit = async (client) => {

    try {
      let body = {
        "number_client": client.number_client !== "" ? client.number_client : null,
        "name": client.name,
        "rfc": client.rfc,
        "phone": client.phone !== "" ? client.phone : null,
        "street": client.street !== "" ? client.street : null,
        "zip_code": client.postalCode !== "" ? client.postalCode : null,
        "city": client.city !== "" ? client.city : null,
        "state": client.state !== "" ? client.state : null,
        "municipality": client.municipality !== "" ? client.municipality : null,
        "colony": client.cologne !== "" ? client.cologne : null,
        "country": client.countryText !== "" ? client.countryText : null,
        "mail": client.email !== "" ? client.email : null,
        "payment_account": client.oracleClient !== "" ? client.oracleClient : null,
        "payment_condition": client.paymentConditions !== "" ? client.paymentConditions : null,
        "payment_method": client.paymentMethod !== "" ? client.paymentMethod : null,
        "prefix": client.customerPrefix !== "" ? client.customerPrefix : null
      }

      if(!currentClient) {
        const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/clients/create`;
        const response = await axios.post(url, body, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`
          }
        })

        closeModal(false, "update");
        Swal.fire("Creado!", "El elemento ha sido Creado.", "success");

      } else {
        const url = `${process.env.REACT_APP_URL_BACKEND}/api/v1/clients/update/${currentClient.id}`;
        const response = await axios.put(url, body, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`
          }
        })

        closeModal(false, "update");
        Swal.fire("Actualizado!", "El elemento ha sido actualizado.", "success");
      }


    } catch (error) {
     console.log(error);
     Swal.fire("Error", "Hubo un error", "error");
    }
  }

  return (
    <>
      <form
        onSubmit={handleSubmit(handleClientSubmit)} 
        className='formClients'
        autoComplete='off'
      >
        <div className='row'>
          {/* Number Client */}
          <div className='col-md-6 col-sm-12'>
            <div className='form-group'>
              <label htmlFor="number_client" className="col-sm-12 text-start">
                No. Cliente
              </label>
              <div className="col-sm-12">
                <input
                  id="number_client"
                  className={`form-control`}
                  placeholder=""
                  name="number_client"
                  type="text"
                  {...register("number_client")}
                />
              </div>
            </div>
          </div>
          {/* Nombre */}
          <div className='col-md-6 col-sm-12'>
            <div className='form-group'>
              <label htmlFor="name" className="col-sm-12 text-start">
                Nombre
                <span className="text-danger">*</span>
              </label>
              <div className="col-sm-12">
                <input
                  id="name"
                  className={`form-control`}
                  placeholder=""
                  name="name"
                  type="text"
                  {...register("name", {
                    required: true
                  })}
                />
                {errors.name?.type === "required" && (
                  <p className='errorText'>Campo requerido</p>
                )}
              </div>
            </div>
          </div>
        </div>
        
        <div className='row'>
          {/* RFC */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label
                htmlFor="rfc"
                className="col-sm-12 text-start"
              >
                RFC
                <span className="text-danger">*</span>
              </label>
              <div className="col-sm-12">
                <input
                  id="rfc"
                  className={`form-control`}
                  name="rfc"
                  type="text"
                  {...register("rfc", {
                    required: true
                  })}
                  // defaultValue={defaultClientData.rfc ? defaultClientData.rfc : ""}
                />
                {errors.rfc?.type === "required" && (
                  <p className='errorText'>Campo requerido</p>
                )}
              </div>
            </div>
          </div>
          {/* Telefono */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="phone" className="col-sm-12 text-start">
                Teléfono
                <span>&nbsp;</span>
              </label>
              <div className="col-sm-12">
                <input
                  id="phone"
                  className={`form-control`}
                  name="phone"
                  type="text"
                  {...register("phone", {
                    pattern: {
                      value: /^\d{10,15}$/,
                      message: 'Número de teléfono inválido'
                    }
                  })}
                  // defaultValue={defaultClientData.phone ? defaultClientData.phone : ""}
                />
                {errors.phone?.type === "pattern" && (
                  <p className='errorText'>Número de teléfono inválido</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          {/* Calle */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="street" className="col-sm-12 text-start">
                Calle
              </label>
              <div className="col-sm-12">
                <input
                  id="street"
                  className={`form-control`}
                  name="street"
                  type="text"
                  {...register("street")}
                />
              </div>
            </div>
          </div>
          {/* Codigo Postal */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label
                htmlFor="postalCode"
                className="col-sm-12 text-start"
              >
                Código Postal
              </label>
              <div className="col-sm-12">
                <input
                  id="postalCode"
                  className={`form-control`}
                  name="postalCode"
                  type="text"
                  maxLength={5}
                  {...register("postalCode")}
                />
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          {/* City */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label
                htmlFor="city"
                className="col-sm-12 text-start"
              >
                Ciudad
              </label>
              <div className="col-sm-12">
                <input
                  id="city"
                  className={`form-control `}
                  name="city"
                  type="text"
                  {...register("city")}
                />
              </div>
            </div>
          </div>
          {/* Estado */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label
                htmlFor="state"
                className="col-sm-12 text-start"
              >
                Estado
              </label>
              <div className="col-sm-12">
                <input
                  id="state"
                  className={`form-control`}
                  name="state"
                  type="text"
                  {...register("state",)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          {/* Municipio */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label
                htmlFor="municipality"
                className="col-sm-12 text-start"
              >
                Municipio
              </label>
              <div className="col-sm-12">
                <input
                  id="municipality"
                  className={`form-control `}
                  name="municipality"
                  type="text"
                  {...register("municipality")}
                />
              </div>
            </div>
          </div>
          {/* Colonia */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label
                htmlFor="cologne"
                className="col-sm-12 text-start"
              >
                Colonia
              </label>
              <div className="col-sm-12">
                <input
                  id="cologne"
                  className={`form-control`}
                  name="cologne"
                  type="text"
                  {...register("cologne")}
                />
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          {/* Country */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label
                htmlFor="country"
                className="col-sm-12 text-start"
              >
                País
              </label>
              <div className="col-sm-12">
                <input
                  id="country"
                  className={`form-control `}
                  name="country"
                  type="text"
                  {...register("countryText")}
                />
              </div>
            </div>
          </div>
          {/* Email */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label
                htmlFor="email"
                className="col-sm-12 text-start"
              >
                Email
              </label>
              <div className="col-sm-12">
                <input
                  id="email"
                  className={`form-control`}
                  name="email"
                  type="text"
                  {...register("email", {
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: 'Email inválido'
                    }
                  })}
                  // defaultValue={defaultClientData.mail ? defaultClientData.mail : ""}
                />
                {errors.email?.type === "pattern" && (
                  <p className='errorText'>Email invalido</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          {/* Oracle Client */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label htmlFor="oracleClient" className="col-sm-12 text-start">
                Cliente Oracle
                <span>&nbsp;</span>
              </label>
              <div className="col-sm-12">
                <input
                  id="oracleClient"
                  className={`form-control`}
                  name="oracleClient"
                  type="text"
                  {...register("oracleClient")}
                />
              </div>
            </div>
          </div>
          {/* Payment Conditions */}
          <div className="col-md-6 col-sm-12">
            <div className={`form-group`}>
              <label htmlFor="paymentConditions" className="col-sm-12 text-start">
                Condiciones de pago
              </label>
              <div className="col-sm-12">
                <select
                  id="paymentConditions"
                  className={`form-control`}
                  name="paymentConditions"
                  {...register("paymentConditions")}
                >
                  <option value="">Selecciona...</option>
                  <option value="1">Contado</option>
                  <option value="2">Credito</option>
                  <option value="3">Credito / PUE</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          {/* Payment Method */}
          <div className="col-md-6 col-sm-12">
            <div className={`form-group`}>
              <label htmlFor="paymentMethod" className="col-sm-12 text-start">
                Método de Pago
              </label>
              <div className="col-sm-12">

                <select
                  id="paymentMethod"
                  className={`form-control`}
                  name="paymentMethod"
                  {...register("paymentMethod")}
                >
                  <option value="">Selecciona...</option>
                  {paymentMethodArr.map((paymentMethod, index) => (
                    <option key={index} value={paymentMethod.id}>{paymentMethod.text}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {/* customer Prefix */}
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <label
                htmlFor="customerPrefix"
                className="col-sm-12 text-start"
              >
                Prefijo cliente 0000
                <span>&nbsp;</span>
              </label>
              <div className="col-sm-12">
                <input
                  id="customerPrefix"
                  className={`form-control`}
                  name="customerPrefix"
                  type="text"
                  {...register("customerPrefix")}
                  // defaultValue={defaultClientData.prefix ? defaultClientData.prefix : ""}
                />
              </div>
            </div>
          </div>
        </div>

        <div className='buttonsSection'>
          <button type='submit'>
            Enviar
          </button>
          <button type='button' onClick={() => closeModal(false, "no-update")}>
            Cancelar
          </button>
        </div>

      </form>
    </>
  )

}

export default FormClient;